<div
    class="option d-flex align-items-center"
    (click)="clickHandler()"
    [attr.data-cy]="configuration?.name"
    [ngClass]="{ active: configuration.isActive, collapsed: menuCollapsed }"
>
    <div class="icon" *ngIf="showIcon">
        <img
            appImageSelector
            alt="mt-image"
            imageType="icon"
            [imageKey]="icon"
        />
    </div>
    
    <div class="description" [hidden]="!detailVisibility" [ngStyle]="{'margin-left': (configuration?.level * 10) + 'px'}">
        <div class="title">
            <span
                [ngClass]="{
                    underline: configuration.underline
                }"
            >
                {{ title | lang }}</span
            >
        </div>
        <div class="detail" *ngIf="configuration.menuParentId === 1">
            {{ detail | lang }}
        </div>
    </div>
    <div
        class="notification"
        *ngIf="configuration.name === 'messages' && totalUnreadMessages > 0"
    >
        {{ totalUnreadMessages > 10 ? "+10" : totalUnreadMessages }}
    </div>

    <div
        *ngIf="configuration.childs.length > 0"
        class="dropdown-sidebar"
        (click)="clickToggle()"
    >
        <em
            class="fa fa-chevron-down"
            [ngStyle]="{
                '-webkit-transform': showChildren
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                '-webkit-transition': showChildren
                    ? 'all 0.3s ease-out'
                    : 'all 0.3s ease-out'
            }"
        ></em>
    </div>
</div>

<div
    *ngIf="!menuCollapsed && configuration.childs.length > 0"
    [hidden]="!showChildren"
>
    <ng-container
        *ngFor="let child of configuration.childs; trackBy: trackByMenuId"
    >
        <app-menu-option
            [configuration]="child"
            [father]="configuration"
        ></app-menu-option>
    </ng-container>
</div>
